<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="no-gutters row">
                <div class="col-lg-4 p-3">
                    <div class="divider-v divider-v-lg"></div>
                    <div class="row">
                        <div class="col">
                            <div class="text-center">
                                <div>
                                    <fa-icon [icon]="['far', 'envelope']" class="font-size-xxl text-info"></fa-icon>
                                </div>
                                <div class="mt-2 line-height-sm">
                                    <b class="font-size-lg">$9,693</b>
                                    <span class="text-black-50 d-block">revenue</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 p-3">
                    <div class="divider-v divider-v-lg"></div>
                    <div class="row">
                        <div class="col">
                            <div class="text-center">
                                <div>
                                    <fa-icon [icon]="['far', 'lightbulb']" class="font-size-xxl text-success"></fa-icon>
                                </div>
                                <div class="mt-2 line-height-sm">
                                    <b class="font-size-lg">2,345</b>
                                    <span class="text-black-50 d-block">users</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 p-3">
                    <div class="row">
                        <div class="col">
                            <div class="text-center">
                                <div>
                                    <fa-icon [icon]="['far', 'keyboard']" class="font-size-xxl text-danger"></fa-icon>
                                </div>
                                <div class="mt-2 line-height-sm">
                                    <b class="font-size-lg">1,024</b>
                                    <span class="text-black-50 d-block">orders</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="no-gutters row">
                <div class="col-lg-6 p-3">
                    <div class="divider-v divider-v-lg"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex p-3">
                                <fa-icon [icon]="['far', 'envelope']" class="display-4 text-info"></fa-icon>
                                <div class="ml-4 line-height-sm">
                                    <b class="font-size-xxl">$9,693</b>
                                    <span class="text-black-50 d-block">revenue</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 p-3">
                    <div class="divider-v divider-v-lg"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex p-3">
                                <fa-icon [icon]="['far', 'lightbulb']" class="display-4 text-success"></fa-icon>
                                <div class="ml-4 line-height-sm">
                                    <b class="font-size-xxl">2,345</b>
                                    <span class="text-black-50 d-block">users</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
